<!--
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: Please set LastEditors
 * @Date: 2019-03-15 10:04:20
 * @LastEditTime: 2022-09-05 17:10:32
 -->
<template>
  <div>
    <el-button
      @click="() => {
        $router.back()
      }"
      type="text"
      style="display:flex"
      icon="el-icon-arrow-left"
    >
      返回
    </el-button>
    <div class="table-box">
      <!-- <p class="title">问卷信息</p>
      <el-table
        :data="userData"
        border
        style="width: 100%;margin-bottom:72px;"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column :show-overflow-tooltip="true" align="center" prop="fullName" label="问卷发起人"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="phone" label="发起人手机号码"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" label="开始时间">
          <template slot-scope="{row}">{{row.answerStartDt | transAllTime}}</template>
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" align="center" label="结束时间">
          <template slot-scope="{row}">{{row.answerEndDt | transAllTime}}</template>
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" align="center" label="答题时间">
          <template slot-scope="{row}">{{(row.answerEndDt - row.answerStartDt) / 1000}} 秒</template>
        </el-table-column>
      </el-table>-->
      <div class="list">
        <p class="title">{{ projectName }}</p>
        <span style="color: grey; font-size: 14px;" v-if="sceneRemark">
          {{ sceneRemark }}
        </span>
        <ul>
          <li v-for="(item, index) in answerList" :key="index">
            <p style="margin-bottom:14px;">
              {{ index + 1 }}：{{ item.title }}
              <span v-if="item.type">[{{ item | questionTypeLabelFil }}]</span>
              <span v-if="![17, 18].includes(item.type)">
                （{{ item.isMustFill === 1 ? '必填' : '非必填' }}）
              </span>
            </p>
            <div
              class="item-p"
              v-if="deal(item.answer) && ![17, 18].includes(item.type)"
            >
              无
            </div>
            <div
              class="item-p"
              v-if="item.remark"
              style="color:grey;font-size:14px;"
            >
              备注：{{ item.remark }}
            </div>
            <div
              v-if="typeof item.answer == 'object' && item.type < 8"
              class="item-p"
            >
              <div
                v-for="(item2, index2) in item.answer"
                :key="index2 + 100"
                v-if="item.answer.length > 0"
              >
                <p v-if="item.type == 5" style="margin-bottom:10px;">
                  {{ item.manyTitleJson[index2] }}：
                </p>
                <p style="margin-bottom:10px;">{{ item2 ? item2 : '无' }}</p>
              </div>
              <div v-else>无</div>
            </div>
            <div class="enclosure" v-else-if="item.type == 8">
              <template
                v-for="(item2, index2) in item.answer"
                v-if="item.answer.length > 0"
              >
                <img
                  v-if="!item2.isPdf"
                  v-amplifyImg="item2.url"
                  :key="index2 + 100"
                  :src="item2.url"
                  alt
                />
                <div v-else @click="open(item2.url)" :key="index2 + 100">
                  <img src="//cdn.yxvzb.com/WEB/images/pdf.jpeg" />
                  <span>{{ item2.name }}</span>
                </div>
              </template>
              <div v-else>无</div>
            </div>
            <div
              v-else-if="fileTypeList.includes(item.type)"
              style="display:flex;flex-wrap:wrap;"
            >
              <div
                class="item-p"
                v-for="(item2, index2) in item.answer"
                :key="index2"
                v-if="item.answer.length > 0"
              >
                <img
                  v-amplifyImg="item2.url"
                  v-if="item.type == 13"
                  :src="item2.url"
                  alt
                  style="margin:5px;"
                />
                <div v-else @click="open(item2.url)" :key="index2 + 100">
                  <span style="color:#409eff">{{ item2.name }}</span>
                </div>
              </div>
              <div v-else>无</div>
            </div>
            <div v-else-if="timeTypeList.includes(item.type)">
              <p class="item-p">{{ item.answer }}</p>
            </div>
            <div v-else-if="item.type == 16" class="item-p">
              <img
                v-amplifyImg="item.answer.addressPicUrl"
                :src="item.answer.addressPicUrl"
                alt
                style="margin:5px;"
                v-if="item.answer.addressPicUrl"
              />
            </div>
            <p class="item-p" v-else-if="item.isLocation">
              <img
                v-amplifyImg="item.answer"
                :src="item.answer"
                alt
                style="margin:5px;"
              />
            </p>
            <div class="item-p" v-else-if="item.type == 20">
              <img
                v-if="item.answer"
                v-amplifyImg="item.answer"
                :src="item.answer"
                alt
                style="margin:5px;"
              />
            </div>
            <pre class="item-p item-pre" v-else>{{
              item.answer === 'null' ? '无' : item.answer
            }}</pre>
          </li>
        </ul>
      </div>
      <div>
        <approveCtrl
          v-if="$route.query.auditGongyeStatus === 1"
          @submit="approve(2)"
          @withdraw="approve(3)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { project, receive } from '@/api/ajax';
import { questionType } from '@/config/staticData';
import { mapState } from 'vuex';
import dateFormat from '@/tools/dateFormat';
import approveCtrl from '@/components/Survey/approveCtrl';
import OpenNewWin from '@/tools/openNewWin';

export default {
  data() {
    return {
      sceneRemark: '',
      answerList: [],
      userData: [],
      searchQuery: {
        projectStructureType: ''
      },
      fileTypeList: [8, 9, 10, 11, 12, 13],
      timeTypeList: [14, 15]
    };
  },
  components: { approveCtrl },
  filters: {
    questionTypeFil(v) {
      return (questionType[v] || { label: '' }).label;
    }
  },
  computed: {
    ...mapState({
      projectName: state => state.homeProject.projectName
    })
  },
  methods: {
    approve(type, data, isAll = 0) {
      receive
        .receiveTaskRecord({
          auditGongyeStatus: type,
          remark: data,
          isAll: isAll,
          statementId: this.$route.query.statementId,
          taskRecordId: this.$route.query.questionnaireAnswerId
        })
        .then(response => {
          this.$message.success(response.data);
          this.$router.go(-1);
        });
    },
    close() {
      this.$router.back();
    },
    open(url) {
      window.open(url);
    },
    deal(v) {
      if (v === null || v === '' || v.length === 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  async created() {
    let { sceneBaseId, userId, answerId, statementId } = this.$route.query;
    if (sceneBaseId && userId && answerId) {
      let {
        data: {
          data: {
            contentTitleList,
            isSetTarget,
            isSetTime,
            isSetLocation,
            targetTitle,
            timeTitle,
            locationTitle,
            targetRemark,
            timeRemark,
            locationRemark,
            customerName,
            startDt,
            endDt,
            visitMinute,
            addressPicUrl,
            sceneRemark,
            timeType,
            timeQuestions
          }
        }
      } = await project.questMakeSceneBaseProjectAnswerListDetail({
        sceneBaseId,
        userId,
        answerId,
        statementId
      });
      startDt = startDt || 0;
      endDt = endDt || 0;
      visitMinute = visitMinute || 0;
      const tArr = [
        {
          title: (targetTitle || '') + '[目标题]',
          remark: targetRemark,
          answer: customerName,
          show: isSetTarget,
          isMustFill: 1
        },
        {
          title:
            (timeTitle || '') + `[${timeType === 1 ? '时间段' : '时刻'}题]`,
          remark: timeRemark,
          answer: timeQuestions || '',
          show: isSetTime,
          isMustFill: 1
        },
        {
          title: (locationTitle || '') + '[定位题]',
          answer: addressPicUrl,
          remark: locationRemark,
          show: isSetLocation,
          isLocation: true,
          isMustFill: 1
        }
      ].filter(item => item.show == 1);
      this.sceneRemark = sceneRemark;
      this.answerList = tArr.concat(
        contentTitleList.map(item => {
          if (
            item.type == 2 ||
            item.type == 5 ||
            (item.type >= 8 && item.type != 19)
          ) {
            try {
              item.answer = JSON.parse(item.answer);
            } catch (error) {}
            if (item.type == 5) {
              item.manyTitleJson = JSON.parse(item.manyTitleJson);
            }
          }
          return item;
        })
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
}
.title {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
}
.item-pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.list {
  text-align: left;

  p {
    font-size: 16px;
  }

  ul {
    li {
      width: 100%;
      border-bottom: 2px solid #f5f5f5;
      margin-bottom: 30px;

      .item-p {
        padding-bottom: 15px;
        padding-left: 20px;
      }
    }
  }
}
.enclosure {
  display: flex;
  img {
    width: 150px;
    height: 150px;
    margin-right: 35px;
  }
  div {
    position: relative;
    span {
      position: absolute;
      width: 95%;
      bottom: 0;
      left: 0;
      color: #fff;
    }
  }
}
</style>
